import React from 'react';
import { connect } from 'react-redux';
import { FooterWithoutLanguage } from 'enlm_ui_common';

const FooterWithoutLanguageSwitch = props => {
  return <FooterWithoutLanguage withPadding={true} {...props} />;
};

const mapStateToProps = state => ({
  locale: state.accountReducer.locale,
  version: state.appReducer.enlightenVersion
});

export default connect(mapStateToProps)(FooterWithoutLanguageSwitch);
